import React, { useEffect, useState } from "react";
import axios from "axios";
import SignoutBlueButton from "../../components/SignoutBlueButton";
import { VscSignOut } from "react-icons/vsc";
import { IoCopyOutline } from "react-icons/io5";
import { MdDone } from "react-icons/md";
import { decryptText } from "../../utils/cipherText";
import QRCode from "qrcode.react";
import QrCode from "./QrCode";
import { BsQrCode } from "react-icons/bs";
import { FaLink } from "react-icons/fa6";

const Profile = () => {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [copyText, setCopyText] = useState(true);
  const [qrModal, setQrModal] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  useEffect(() => {
    const fetchProfileDetails = async () => {
      const token = localStorage.getItem("token");
      const options = {
        method: "GET",
        headers: { Authorization: token },
      };
      try {
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/profile`,
          options
        );
        setProfileDetails(res.data.profile);

        // setRowsPerPage(res.data.order_details.length);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProfileDetails();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(profileDetails.link_name);
    setCopyText(false);

    setTimeout(() => setCopyText(true), 3000);
  };
  // console.log('apiProfileData');
  // console.log(apiProfileData);
  // let { name, email, address, contact_name, capacity, position } = apiProfileData;

  const handleModal = () => {
    setQrModal((prev) => !prev);
  };
  return (
    <div className="employees justify-center">
      <div style={{ width: "100%" }}>{/* <Navbar /> */}</div>
      <div className="flex flex-col px-16 -mt-32">
        <div className="rounded-full border border-[#D1D5DB] w-[120px] h-[120px] flex items-center justify-center">
          <img src={profileDetails.logo} alt="" className="w-[80px] h-[70px]" />
        </div>
        {userType === "distributors" && (
          <div className="mt-6 ">
            <p className="text-xs mb-1 font-medium">Distributor's link</p>
            <div className="flex items-center w-[70%]  text-xs font-medium">
              {" "}
              <div className=" flex items-center  ">
                <p className=" font-semibold  bg-[#f1f4f5] pr-[6px] py-1 pl-4  rounded mr-[12px] flex items-center">
                  <span className=" mr-4 text-[10px] font-medium text-[#6b778e]">
                    {profileDetails.link_name}
                  </span>
                  <span>
                    {" "}
                    <div className=" border border-[#cdd1d2] flex px-3 py-1 rounded-lg items-center text-xs bg-white">
                      {copyText ? (
                        <>
                          <FaLink
                            className="w-[16px] h-[16px]  cursor-pointer mr-2"
                            onClick={handleCopy}
                          />
                          <p
                            onClick={handleCopy}
                            className="cursor-pointer text-xs"
                          >
                            Copy Link
                          </p>
                        </>
                      ) : (
                        <>
                          <MdDone className="w-[16px] h-[16px] mr-2" />
                          <p className="text-xs">Link Copied</p>
                        </>
                      )}
                    </div>
                  </span>
                </p>
              </div>
              <p className="text-sm mx-12">or</p>
              <button
                className="border border-[#aeaeae] bg-[#f1f4f5] px-[18px] py-[8px] flex items-center rounded-lg text-xs "
                onClick={handleModal}
              >
                {" "}
                <span className=" mr-3 text-[#00394d]">
                  <BsQrCode className="w-[16px] h-[16px]" />
                </span>{" "}
                Scan QR code
              </button>
            </div>
          </div>
        )}
        <div className="mt-6 border-b border-[#D1D5DB] w-[60%]">
          <div className="divide-y divide-[#D1D5DB]">
            <div className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">
                Name
              </dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-0">
                {profileDetails.name}
              </dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">
                Email
              </dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-0">
                {profileDetails.email}
              </dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">
                GST Number
              </dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-0">
                {profileDetails.gst || "--"}
              </dd>
            </div>
          </div>
        </div>
        <div className=" w-[60%] flex justify-between items-center">
          <SignoutBlueButton text={"signout"} icon={() => <VscSignOut />} />

          {/* <button onClick={handleCopy}>Copy</button> */}
        </div>
      </div>
      {qrModal && (
        <QrCode link={profileDetails.link_name} close={handleModal} />
      )}
    </div>
  );
};

export default Profile;
